const translations = {
  common: {
    search: 'Pesquisar',
    searching: 'Pesquisando',
    signIn: 'Entrar',
    register: 'Registrar',
    myAccount: 'Minha Conta',
    support: 'Suporte',
    followUs: 'Siga-nos no X/Twitter',
    proMembership: 'Assinatura Pro',
    new: 'Novo',
    proMember: 'Membro Pro',
    upgrade: 'Melhorar',
    subscribe: 'Assinar',
    manage: 'Gerenciar',
    cancel: 'Cancelar',
    close: 'Fechar',
    or: 'Ou',
    email: 'Endereço de e-mail',
    continue: 'Continuar',
    submit: 'Enviar',
    billing: 'Faturamento',
    sort: 'Ordenar',
    language: 'Idioma',
    selectLanguage: 'Selecionar Idioma',
    searchPlaceholder: 'Pesquisar...',
    cards: 'Cartas',
    previous: 'Anterior',
    next: 'Próximo',
    pagination: 'Paginação',
    back: 'Voltar',
    backToSets: 'Voltar para Coleções',
    error: 'Ocorreu um erro. Por favor, tente novamente.',
    home: 'Início',
    sets: 'Coleções',
    login: 'Entrar',
    loginRequired: 'Por favor, faça login para acessar este recurso',
    adding: 'Adicionando...',
  },
  languages: {
    default: 'Padrão',
    any: 'Qualquer',
    english: 'Inglês',
    spanish: 'Espanhol',
    french: 'Francês',
    german: 'Alemão',
    italian: 'Italiano',
    portuguese: 'Português',
    japanese: 'Japonês',
    korean: 'Coreano',
    russian: 'Russo',
    simplified_chinese: 'Chinês Simplificado',
    traditional_chinese: 'Chinês Tradicional',
    hebrew: 'Hebraico',
    latin: 'Latim',
    ancient_greek: 'Grego Antigo',
    arabic: 'Árabe',
    sanskrit: 'Sânscrito',
    phyrexian: 'Phyrexiano',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Mostrar Filtros Pro',
    hide: '✨ Ocultar Filtros Pro',
  },
  search: {
    showing_start: 'Mostrando',
    showing_to: 'até',
    showing_of: 'de',
    showing_results: 'resultados',
    noResults: 'Nenhum resultado encontrado.',
    useSearchTip: 'Use a pesquisa no topo da página para procurar uma carta.',
  },
  sort: {
    nameAsc: 'Nome (A a Z)',
    nameDesc: 'Nome (Z a A)',
    cmcAsc: 'Valor de Mana (Menor para Maior)',
    cmcDesc: 'Valor de Mana (Maior para Menor)',
    usdAsc: 'Preço (Menor para Maior)',
    usdDesc: 'Preço (Maior para Menor)',
    rarityAsc: 'Raridade (Comum para Mítica)',
    rarityDesc: 'Raridade (Mítica para Comum)',
    releasedDesc: 'Data de Lançamento (Mais Recente Primeiro)',
    releasedAsc: 'Data de Lançamento (Mais Antigo Primeiro)',
  },
  pages: {
    search: {
      heading: 'Pesquisa de Cartas MTG',
    },
    sets: {
      heading: 'Coleções de Cartas',
      latestSets: 'Coleções Mais Recentes',
      upcomingSets: 'Próximas Coleções',
      allSets: 'Todas as Coleções',
      noResults: 'Nenhum resultado encontrado.',
    },
    set: {
      notFound: 'Coleção não encontrada.',
      noCards: 'Nenhuma carta encontrada nesta coleção.',
      addAll: 'Adicionar {{count}} Cartas à Lista de Proxy',
      addedToList: 'Adicionadas {{count}} cartas à Lista de Proxy',
    },
    tokens: {
      heading: 'Fichas',
    },
    emblems: {
      heading: 'Emblemas',
    },
    import: {
      heading: 'Importar cartas para a Lista de Proxy',
      description: 'Insira os nomes de todas as cartas que deseja adicionar à Lista de Proxy.',
    },
    topProxies: {
      heading: 'Proxies Populares',
      description: 'Aqui estão as 50 cartas proxy MTG mais populares no TCG Stacked.',
    },
  },
  theme: {
    light: 'Claro',
    dark: 'Escuro',
    toggle: 'Alternar tema',
  },
  cta: {
    title: 'Pronto para começar?',
    subtitle: 'Comece a criar proxies hoje mesmo.',
    searchByCard: 'Pesquisar por carta',
    searchBySet: 'Pesquisar por conjunto',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Pokémon',
    sets: 'Coleções',
    tokens: 'Fichas',
    emblems: 'Emblemas',
    import: 'Importar',
    topProxies: 'Proxies Populares',
    customCards: 'Cartas Personalizadas',
    deckBuilder: 'Construtor de Deck',
    buildDeck: 'Construir Deck',
    publicDecks: 'Decks Públicos',
    favoriteDeck: 'Meus Decks Favoritos',
    articles: 'Artigos',
    feedback: 'Compartilhar Feedback',
    collection: 'Minha Coleção',
    pokemonSets: 'Coleções de Pokémon',
    pokemonSearch: 'Pesquisar Cartas Pokémon',
  },
  seo: {
    collection: {
      title: 'Minha Coleção de Cartas | TCG Stacked',
      description: 'Gerencie sua coleção pessoal de cartas. Acompanhe, organize e avalie suas cartas de Magic: The Gathering em um só lugar.',
    },
    home: {
      title: 'TCG Stacked - Cartas Proxy de Jogos de Cartas Colecionáveis',
      description: 'Acesse uma vasta biblioteca de cartas proxy de jogos de cartas colecionáveis. Visualize e imprima facilmente imagens de cartas para jogo casual. Comece a construir o deck dos seus sonhos hoje!',
    },
    sets: {
      title: 'Coleções de Cartas - TCG Stacked',
      description: 'Explore todas as coleções de cartas colecionáveis e imprima proxies para seu deck.',
    },
    tokens: {
      title: 'Fichas - TCG Stacked',
      description: 'Melhore seu jogo com várias fichas proxy.',
    },
    emblems: {
      title: 'Emblemas - TCG Stacked',
      description: 'Imprima cartas proxy de emblemas para seu deck.',
    },
    search: {
      title: 'Pesquisa de Cartas - TCG Stacked',
      description: 'Encontre e imprima cartas proxy facilmente. Use as ferramentas de pesquisa para acessar um vasto banco de dados e melhore seus decks com proxies.',
    },
    support: {
      title: 'Suporte - TCG Stacked',
      description: 'Envie-nos um e-mail se você tiver dúvidas, feedback ou quiser adicionar fichas/emblemas.',
    },
    articles: {
      title: 'Artigos - TCG Stacked',
      description: 'Artigos sobre jogos de cartas colecionáveis e cartas proxy.',
    },
    import: {
      title: 'Importar - TCG Stacked',
      description: 'Importe uma lista de cartas para imprimir proxies de jogos de cartas colecionáveis.',
    },
    topProxies: {
      title: 'Proxies Populares - TCG Stacked',
      description: 'Veja as cartas proxy mais populares no TCG Stacked.',
    },
    customCards: {
      title: 'Cartas Personalizadas - TCG Stacked',
      description: 'Crie suas próprias cartas proxy de jogos de cartas colecionáveis.',
    },
    login: {
      title: 'Entrar - TCG Stacked',
      description: 'Entre em sua conta para gerenciar cartas personalizadas, listas de deck e mais.',
    },
    register: {
      title: 'Registrar - TCG Stacked',
      description: 'Registre uma conta para gerenciar cartas personalizadas, listas de deck e mais.',
    },
    termsOfService: {
      title: 'Termos de Serviço - TCG Stacked',
      description: 'Leia os termos de serviço do site.',
    },
    privacyPolicy: {
      title: 'Política de Privacidade - TCG Stacked',
      description: 'Leia a política de privacidade do site.',
    },
    account: {
      title: 'Conta - TCG Stacked',
      description: 'Gerencie sua conta.',
    },
    proMembership: {
      title: 'Assinatura Pro - TCG Stacked',
      description: 'Assine a assinatura Pro para acessar todos os recursos do site.',
    },
    deckBuilder: {
      title: 'Construtor de Deck - TCG Stacked',
      description: 'Crie e gerencie seus decks de jogos de cartas colecionáveis.',
    },
    deckEditor: {
      title: 'Editor de Deck - TCG Stacked',
      description: 'Crie e edite seus decks de jogos de cartas colecionáveis.',
    },
    publicDecks: {
      title: 'Decks Públicos - TCG Stacked',
      description: 'Navegue e explore decks públicos compartilhados pela comunidade.',
    },
  },
  pro: {
    pricing: {
      title: 'Potencialize Sua Experiência de Proxy',
      subtitle: 'Torne-se Pro e desfrute de uma experiência premium sem anúncios com recursos exclusivos que elevam seus proxies ao próximo nível!',
      monthlyPlan: 'Impulso Mensal',
      yearlyPlan: 'Super Valor Anual',
      monthlyPrice: 'R$25,00/mês',
      yearlyPrice: 'R$200,00/ano',
      subscribeMonthly: 'Comece Agora',
      subscribeYearly: 'Economize Anualmente',
      signInToSubscribe: 'Entre para Desbloquear Pro',
      manageSubscription: 'Gerencie Seus Benefícios Pro',
      nextBillingDate: 'Seu Próximo Pagamento',
      benefitsEndDate: 'Acesso Pro até',
      viewInvoice: 'Ver Recibo',
      changePlan: 'Alterar Seu Plano',
      reactivate: 'Restaurar Benefícios Pro',
      active: 'Ativa e Próspera',
      cancelled: 'Cancelada',
      freeTrial: 'Teste Gratuito',
      freeTrialEnds: 'O Teste Gratuito Termina',
      startFreeTrial: 'Iniciar Teste Gratuito de 7 Dias',
      signInForFreeTrial: 'Entre para o Teste Gratuito de 7 Dias',
      current: 'Atual',
    },
    benefits: {
      title: 'Por Que Escolher Pro com TCG Stacked?',
      subtitle: 'Junte-se a milhares de jogadores que melhoraram sua experiência de proxies com estes recursos Pro exclusivos!',
      noAds: {
        title: 'Experiência Pura Sem Anúncios',
        description: 'Adeus interrupções! Desfrute de uma interface impecável sem anúncios, banners ou pop-ups. A experiência de jogo em estado puro.',
      },
      darkMode: {
        title: 'Modo Escuro Épico',
        description: 'Suave para seus olhos e elegante! Perfeito para nottivagos e sessões maratona de proxies em qualquer condição de iluminação.',
      },
      advancedSearch: {
        title: 'Magia de Pesquisa Pro',
        description: 'Encontre exatamente o que você precisa com filtros poderosos! Filtre por identidade de cor, raridade, tipo de carta e mais para construir o deck perfeito.',
      },
      multipleDecks: {
        title: 'Criação Ilimitada de Decks',
        description: 'Paraíso dos construtores de decks! Crie e salve quantos decks quiser - desde diversão casual até poderosas máquinas competitivas.',
      },
      futureFeatures: {
        title: 'Acesso Prioritário a Novidades',
        description: 'Na vanguarda da inovação! Membros Pro sempre têm prioridade nas novas e empolgantes funcionalidades assim que são lançadas.',
      },
      cancelAnytime: {
        title: 'Zero Risco, Todos os Benefícios',
        description: 'Liberdade total! Sem contratos de longo prazo ou taxas ocultas. Cancele com um simples clique quando quiser.',
      },
      prioritySupport: {
        title: 'Acesso ao Suporte VIP',
        description: 'Sem esperas! Suas perguntas e dúvidas recebem tratamento prioritário com nossa equipe de suporte dedicada.',
      },
    },
    features: {
      unlimitedDecks: 'Criação ilimitada de decks',
      noAds: 'Experiência de proxies sem anúncios',
      prioritySupport: 'Acesso ao suporte VIP',
      darkMode: 'Interface modo escuro elegante',
      advancedSearch: 'Filtros e ferramentas Pro de pesquisa',
      futureFeatures: 'Funcionalidades exclusivas a caminho',
      cancelAnytime: 'Cancelamento sem complicações',
    },
    promotion: {
      title: 'Liberte a Criação Ilimitada de Decks',
      description: 'Rompa os limites! Torne-se Pro agora e construa quantos decks sua imaginação permitir.',
      customizeTitle: 'Transforme suas Cartas com a Magia da IA',
      customizeDescription: 'Atualize para Pro e crie até 5 variantes personalizadas de cartas diariamente com nossa tecnologia de IA de ponta!',
      banner: 'Experimente o Pro gratuitamente por 7 dias! Sem anúncios, modo escuro, decks ilimitados e mais.',
      tryNow: 'Experimente Agora',
    },
    account: {
      title: 'Sua Assinatura Pro',
      description: 'Gerencie seus benefícios premium',
      subscribeToPro: 'Torne-se Pro Agora',
    },
  },
  auth: {
    signIn: {
      title: 'Entre em sua Conta',
      withGoogle: 'Continuar com Google',
      withEmail: 'Ou continuar com',
      sendMagicLink: 'Enviar Link Mágico',
      noAccount: 'Não tem uma conta?',
      checkEmail: 'Verifique seu e-mail para o link de login',
      errors: {
        failed: 'Falha no Login',
        failedGoogle: 'Falha no Login com Google',
        failedEmail: 'Falha no Login por E-mail',
        noEmail: 'E-mail não encontrado',
      },
      terms: 'Ao entrar, você concorda com:',
    },
    register: {
      title: 'Criar uma Conta',
      haveAccount: 'Já tem uma conta?',
      terms: 'Ao criar uma conta, você concorda com:',
    },
    common: {
      termsOfService: 'Termos de Serviço',
      privacyPolicy: 'Política de Privacidade',
      and: 'e',
    },
  },
  home: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['cartas', 'fichas', 'emblemas', 'planeswalkers', 'comandantes', 'terrenos', 'criaturas', 'artefatos', 'encantamentos', 'instantâneos'],
      description: 'O TCG Stacked ajuda você a criar proxies de cartas de jogos de cartas colecionáveis para usar em seus decks casuais gratuitamente!',
      search: {
        cards: {
          tab: 'Cartas',
          placeholder: 'Pesquisar carta colecionável...',
          error: 'Falha ao carregar cartas aleatórias',
        },
        sets: {
          tab: 'Coleções',
          placeholder: 'Pesquisar coleção de cartas colecionáveis...',
        },
        tokens: {
          tab: 'Fichas',
          placeholder: 'Pesquisar ficha de cartas colecionáveis...',
        },
        button: 'Pesquisar',
        hint: {
          cards: 'Pressione Enter ou clique em Pesquisar para encontrar suas cartas',
          sets: 'Pressione Enter ou clique em Pesquisar para encontrar suas coleções',
          tokens: 'Pressione Enter ou clique em Pesquisar para encontrar suas fichas',
        },
        aria: {
          searchIcon: 'Ícone de pesquisa',
          searchInput: {
            cards: 'Pesquisar cartas',
            sets: 'Pesquisar coleções',
            tokens: 'Pesquisar fichas',
          },
        },
      },
      images: {
        cardAlt: 'Imagem de carta Magic',
      },
      processedCount: '🎉 Processamos mais de {{count}} proxies gratuitas para a comunidade! 🎉',
    },
    features: {
      section1: {
        badge: 'Imprimir Proxies',
        title: 'Imprimir Cartas Proxy',
        subtitle: 'Adicione cartas à sua lista de impressão, imprima-as e use-as em seus decks hoje mesmo!',
        features: [
          {
            name: 'Adicione cartas à sua lista de impressão',
            description: 'Pesquise qualquer carta usando a página de Pesquisa ou navegue por coleção e adicione as cartas desejadas à sua lista de impressão.',
          },
          {
            name: 'Imprima suas cartas',
            description: 'Depois de adicionar todas as cartas desejadas à sua lista de impressão, você pode imprimi-las e usá-las em seus decks.',
          },
          {
            name: 'Use-as em seus decks',
            description: 'Depois de imprimir suas cartas, você pode usá-las em seus decks. Recorte-as e cole-as em um terreno básico ou use uma sleeve com um terreno básico dentro.',
          },
        ],
        images: {
          cartScreenshot: 'Captura de tela do carrinho mostrando como adicionar cartas à sua lista de impressão',
        },
      },
      section2: {
        badge: 'Construtor de Deck',
        title: 'Construa e gerencie Decks de Jogos de Cartas Colecionáveis',
        subtitle: 'Crie e gerencie seus próprios decks, ou navegue pelos decks públicos criados pela comunidade.',
        features: [
          {
            name: 'Gerencie seus Decks',
            description: 'Todos os usuários podem criar e gerenciar um deck. Membros Pro podem criar um número ilimitado de decks.',
          },
          {
            name: 'Imprima suas cartas',
            description: 'Depois de adicionar todas as cartas desejadas ao seu deck, você pode adicioná-las à sua Lista de Impressão de uma só vez.',
          },
          {
            name: 'Navegue pelos Decks Públicos',
            description: 'Adicione decks completos criados pela comunidade à sua Lista de Impressão para testar facilmente novos decks.',
          },
        ],
        images: {
          deckBuilderScreenshot: 'Interface do Construtor de Deck mostrando como gerenciar seus decks',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, Todos os direitos reservados.',
    disclaimer: 'TCG Stacked não é produzido, endossado, apoiado ou afiliado a nenhum editor de jogos de cartas colecionáveis.',
    affiliate: 'Como parceiro afiliado da TCGplayer, a TCG Stacked pode receber uma comissão em compras qualificadas.',
    builtBy: 'Desenvolvido por',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    support: 'Suporte',
  },
  languages: {
    default: 'Padrão',
    any: 'Qualquer',
    english: 'Inglês',
    spanish: 'Espanhol',
    french: 'Francês',
    german: 'Alemão',
    italian: 'Italiano',
    portuguese: 'Português',
    japanese: 'Japonês',
    korean: 'Coreano',
    russian: 'Russo',
    simplified_chinese: 'Chinês simplificado',
    traditional_chinese: 'Chinês tradicional',
    hebrew: 'Hebraico',
    latin: 'Latim',
    ancient_greek: 'Grego antigo',
    arabic: 'Árabe',
    sanskrit: 'Sânscrito',
    phyrexian: 'Phyrexiano',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Mostrar filtros Pro',
    hide: '✨ Ocultar filtros Pro',
  },
  search: {
    showing_start: 'Mostrando',
    showing_to: 'a',
    showing_of: 'de',
    showing_results: 'resultados',
    noResults: 'Nenhum resultado encontrado.',
    useSearchTip: 'Use a pesquisa no topo da página para procurar uma carta.',
  },
  sort: {
    nameAsc: 'Nome (A a Z)',
    nameDesc: 'Nome (Z a A)',
    cmcAsc: 'Valor de Mana (Baixo para Alto)',
    cmcDesc: 'Valor de Mana (Alto para Baixo)',
    usdAsc: 'Preço (Baixo para Alto)',
    usdDesc: 'Preço (Alto para Baixo)',
    rarityAsc: 'Raridade (Comum para Mítica)',
    rarityDesc: 'Raridade (Mítica para Comum)',
    releasedDesc: 'Data de Lançamento (Mais Recente)',
    releasedAsc: 'Data de Lançamento (Mais Antiga)',
  },
  pages: {
    search: {
      heading: 'Pesquisar',
    },
    sets: {
      heading: 'Coleções de Cartas',
      latestSets: 'Coleções Recentes',
      upcomingSets: 'Próximas Coleções',
      allSets: 'Todas as Coleções',
      noResults: 'Nenhum resultado encontrado.',
    },
    set: {
      notFound: 'Coleção não encontrada.',
      noCards: 'Nenhuma carta encontrada nesta coleção.',
      addAll: 'Adicionar {{count}} Cartas à Lista de Impressão',
      addedToList: 'Adicionadas {{count}} cartas à Lista de Impressão',
    },
    tokens: {
      heading: 'Fichas',
    },
    emblems: {
      heading: 'Emblemas',
    },
    import: {
      heading: 'Importar cartas para Lista de Impressão',
      description: 'Digite os nomes de todas as cartas que você deseja adicionar à Lista de Impressão.',
    },
    topProxies: {
      heading: 'Proxies Populares',
      description: 'Aqui estão as 50 cartas proxy mais populares no TCG Stacked.',
    },
  },
  advancedFilters: {
    colors: 'Cores',
    rarity: 'Raridade',
    cardTypes: 'Tipos de Carta',
    format: 'Formato',
    manaValue: 'Valor de Mana',
    cardName: 'Nome da Carta',
    cardText: 'Texto da Carta',
    specialCharacteristics: 'Características Especiais',
    activeFilters: 'Filtros Ativos',
    clearAll: 'Limpar Tudo',
    applyFilters: 'Aplicar Filtros',
    searchCardName: 'Pesquisar nome da carta...',
    searchCardText: 'Pesquisar texto da carta...',
    namePrefix: 'Nome: ',
    manaPrefix: 'Mana: ',
    textPrefix: 'Texto: ',
    removeFromFilter: '✕',
    selectLanguage: 'Selecionar idioma',
  },
  card: {
    addToPrintList: 'Adicionar à lista de impressão',
    removeFromPrintList: 'Remover da lista de impressão',
    cardsInPrintList: 'carta na lista de impressão',
    cardsInPrintListPlural: 'cartas na lista de impressão',
    buyOn: 'Comprar no TCGplayer',
    buyFor: 'Comprar por ',
    viewDetails: 'Ver detalhes',
    type: 'Tipo',
    manaCost: 'Custo de mana',
    rarity: 'Raridade',
    artist: 'Artista',
    collectorNumber: 'Número do colecionador',
    oracleText: 'Texto Oracle',
    youMightAlsoLike: 'Você também pode gostar...',
    noRecommendations: 'Nenhuma recomendação disponível no momento.',
    details: 'Detalhes',
    rulings: 'Regras',
    legality: 'Legalidade',
    share: 'Compartilhar',
    favorite: 'Favorito',
    noRulings: 'Não há regras disponíveis para esta carta.',
    noLegalityInfo: 'Não há informações de legalidade disponíveis para esta carta.',
    published: 'Publicado',
    legal: 'Legal',
    restricted: 'Restrito',
    banned: 'Banido',
    format: 'Formato',
    status: 'Status',
    viewMore: 'Ver mais',
    viewLess: 'Ver menos',
    customizeWithAI: 'Personalizar com IA',
    otherVersions: 'Impressões únicas',
    showUniqueVersions: 'Mostrar impressões únicas',
    hideUniqueVersions: 'Ocultar impressões únicas',
  },
  cart: {
    title: 'Lista de impressão',
    closePanel: 'Fechar painel',
    empty: 'Nenhum proxy na lista de impressão.',
    addPadding: 'Adicionar preenchimento',
    paperSize: 'Tamanho do papel',
    scale: 'Escala',
    clearCardList: 'Limpar lista',
    print: 'Imprimir',
    success: 'Sucesso!',
  },
  setsList: {
    showing: 'Mostrando',
    to: 'até',
    of: 'de',
    results: 'resultados',
    searchPlaceholder: 'Pesquisar...',
  },
  customizeCardModal: {
    title: 'Personalizar Carta com IA',
    description: 'Descreva como você deseja personalizar esta carta. A IA gerará uma nova versão mantendo a estrutura e o quadro da carta.',
    buttonText: 'Personalizar com IA',
    placeholder: 'Descreva sua variação personalizada da carta...',
    generateButton: 'Gerar Carta Personalizada',
    generatingButton: 'Gerando...',
    addToPrintListButton: 'Adicionar à Lista de Impressão',
    successMessage: 'Carta personalizada adicionada à lista de impressão',
    remainingGenerationsOne: '{{count}} geração restante neste mês',
    remainingGenerationsOther: '{{count}} gerações restantes neste mês',
    error: {
      failed: 'Falha ao gerar carta personalizada',
    },
  },
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Compartilhe Seu Feedback',
    description: 'Valorizamos sua opinião para melhorar o TCG Stacked. Por favor, compartilhe seus pensamentos conosco.',
    categoryLabel: 'Categoria',
    categories: {
      bug: 'Relatório de Bug',
      feature: 'Solicitação de Recurso',
      improvement: 'Sugestão de Melhoria',
      general: 'Feedback Geral',
      other: 'Outro',
    },
    messageLabel: 'Seu Feedback',
    messagePlaceholder: 'Por favor, compartilhe seus pensamentos, sugestões ou relate um problema...',
    ratingLabel: 'Avalie Sua Experiência (Opcional)',
    emailLabel: 'Email (Opcional)',
    emailPlaceholder: 'seu@email.com',
    emailHelp: 'Forneça seu email se quiser que entremos em contato com você.',
    submitting: 'Enviando...',
    submitButton: 'Enviar Feedback',
    successMessage: 'Obrigado pelo seu feedback!',
    errorMessage: 'Falha ao enviar feedback. Por favor, tente novamente.',
  },
  collection: {
    title: 'Minha Coleção',
    loginRequired: 'Login Necessário',
    loginMessage: 'Por favor, faça login para visualizar sua coleção',
    emptyCollection: 'Nenhuma Carta Encontrada',
    emptyCollectionMessage: 'Sua coleção está vazia. Adicione cartas da página de detalhes da carta ou use a função Adicionar em Massa.',
    noMatchingCards: 'Nenhuma carta corresponde aos seus filtros.',
    searchPlaceholder: 'Pesquisar cartas...',
    sortBy: 'Ordenar por',
    sortName: 'Nome',
    sortPrice: 'Preço',
    sortDate: 'Data Adicionada',
    sortQuantity: 'Quantidade',
    filterRarity: 'Raridade',
    filterSet: 'Coleção',
    allRarities: 'Todas as Raridades',
    allSets: 'Todas as Coleções',
    filters: 'Filtros',
    clearFilters: 'Limpar Filtros',
    sortAscending: 'Ordenar Crescente',
    sortDescending: 'Ordenar Decrescente',
    bulkAdd: 'Adicionar em Massa',
    bulkAddTitle: 'Adicionar Cartas da Lista de Impressão',
    bulkAddDescription: 'Adicione todas as cartas da sua lista de impressão à sua coleção.',
    bulkAddCount: '{{count}} cartas serão adicionadas à sua coleção.',
    emptyCart: 'Sua lista de impressão está vazia',
    bulkAddSuccess: 'Cartas adicionadas à coleção',
    bulkAddError: 'Falha ao adicionar cartas à coleção',
    addToCollection: 'Adicionar à Coleção',
    addMore: 'Adicionar Mais',
    inCollection: 'Na Coleção',
    quickAdd: 'Adição Rápida',
    searchCards: 'Pesquisar cartas...',
    typeToSearch: 'Digite pelo menos 3 caracteres para pesquisar',
    noResults: 'Nenhum resultado encontrado',
    noCardSelected: 'Nenhuma carta selecionada',
    addCardToCollection: 'Adicionar Carta à Coleção',
    addCardDescription: 'Especifique a quantidade a ser adicionada à sua coleção.',
    quantity: 'Quantidade',
    price: 'Preço',
    addToCart: 'Adicionar à Lista de Impressão',
    addedToCart: 'Coleção adicionada à lista de impressão',
    stats: 'Estatísticas da Coleção',
    totalValue: 'Valor Total',
    filteredValue: 'Valor Filtrado',
    cardCount: 'Contagem de Cartas',
    totalCards: 'cartas totais',
    uniqueCards: 'cartas únicas',
    filteredCards: 'cartas filtradas',
    rarityBreakdown: 'Distribuição por Raridade',
    export: 'Exportar Coleção',
    exporting: 'Exportando...',
    exportSuccess: 'Coleção exportada com sucesso',
    exportError: 'Falha ao exportar coleção',
    noCardsToExport: 'Nenhuma carta para exportar',
    exportCardName: 'Nome da Carta',
    exportSet: 'Coleção',
    exportRarity: 'Raridade',
    exportQuantity: 'Quantidade',
    exportPrice: 'Preço',
    exportTotalValue: 'Valor Total',
    exportDateAdded: 'Data Adicionada',
    insights: 'Insights da Coleção',
    noInsightsAvailable: 'Nenhum insight disponível para sua coleção',
    insightsDescription: 'Estatísticas detalhadas sobre sua coleção',
    rarityDistribution: 'Distribuição por Raridade',
    topSets: 'Coleções Principais',
    priceDistribution: 'Distribuição de Preços',
    // Quick add feature
    quickAdd: 'Adição Rápida',
    searchCards: 'Buscar cartas para adicionar',
    typeToSearch: 'Digite pelo menos 3 caracteres para buscar',
    noResults: 'Nenhum resultado encontrado',
    noCardSelected: 'Nenhuma carta selecionada',
    addCardToCollection: 'Adicionar Carta à Coleção',
    addCardDescription: 'Especifique a quantidade para adicionar à sua coleção',
    quantity: 'Quantidade',
    price: 'Preço',
    // Clear collection feature
    clearCollection: 'Limpar Coleção',
    clearCollectionConfirmTitle: 'Limpar Toda a Sua Coleção?',
    clearCollectionConfirmMessage: 'Esta ação não pode ser desfeita. Todas as cartas em sua coleção serão removidas permanentemente.',
    // Edit card in collection
    editCardInCollection: 'Editar Carta na Coleção',
    editCardDescription: 'Atualize os detalhes desta carta em sua coleção.',
    viewCardDetails: 'Ver Detalhes da Carta',
    condition: 'Condição',
    selectCondition: 'Selecionar condição',
    language: 'Idioma',
    selectLanguage: 'Selecionar idioma',
    finish: 'Acabamento',
    selectFinish: 'Selecionar acabamento',
    purchasePrice: 'Preço de Compra',
    isProxy: 'Isto é um proxy',
    saveChanges: 'Salvar Alterações',
    removeCard: 'Remover Carta',
    cardRemoved: 'Carta removida da coleção',
    errorRemovingCard: 'Erro ao remover carta da coleção',
    errorSavingChanges: 'Erro ao salvar alterações na carta',
    // Landing page
    landing: {
      title: 'Gerencie Sua Coleção MTG',
      description: 'Acompanhe todas as suas cartas Magic: The Gathering em um só lugar com nossas poderosas ferramentas de gerenciamento de coleção.',
      intro: 'Nosso sistema de gerenciamento de coleção permite que você acompanhe, organize e avalie facilmente toda a sua coleção de cartas Magic: The Gathering. Crie uma conta hoje mesmo para começar!',
      createAccount: 'Criar Conta',
      getStarted: 'Começar Agora',
      howItWorks: 'Como Funciona',
      step1: 'Crie uma conta gratuita para acessar sua coleção pessoal',
      step2: 'Adicione cartas à sua coleção manualmente ou importe de um arquivo CSV',
      step3: 'Organize suas cartas por coleção, cor, raridade e mais',
      step4: 'Acompanhe o valor da sua coleção ao longo do tempo',
      step5: 'Exporte os dados da sua coleção quando precisar',
    },
    features: {
      track: {
        title: 'Acompanhe Suas Cartas',
        description: 'Mantenha um inventário detalhado de todas as suas cartas Magic: The Gathering em um só lugar',
      },
      organize: {
        title: 'Organize por Coleção',
        description: 'Classifique e filtre sua coleção por coleção, raridade, cor e mais',
      },
      value: {
        title: 'Monitore o Valor',
        description: 'Visualize o valor atual de mercado de toda a sua coleção de uma só vez',
      },
      export: {
        title: 'Exporte Dados',
        description: 'Exporte os dados da sua coleção para uso em outros aplicativos',
      },
    },
  },
  pages: {
    search: {
      heading: 'Pesquisar',
    },
    sets: {
      heading: 'Coleções de Cartas',
      latestSets: 'Coleções Mais Recentes',
      upcomingSets: 'Próximas Coleções',
      allSets: 'Todas as Coleções',
      noResults: 'Nenhum resultado encontrado.',
    },
    set: {
      notFound: 'Coleção não encontrada.',
      noCards: 'Nenhuma carta encontrada nesta coleção.',
      addAll: 'Adicionar {{count}} Cartas à Lista de Impressão',
      addedToList: 'Adicionadas {{count}} cartas à Lista de Impressão',
    },
    tokens: {
      heading: 'Fichas',
    },
    emblems: {
      heading: 'Emblemas',
    },
    import: {
      heading: 'Importar cartas para Lista de Impressão',
      description: 'Insira os nomes de todas as cartas que deseja adicionar à Lista de Impressão.',
    },
    topProxies: {
      heading: 'Proxies Populares',
      description: 'Aqui estão as 50 cartas proxy de MTG mais populares no TCG Stacked.',
    },
  },
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Compartilhe Seu Feedback',
    description: 'Valorizamos sua opinião para melhorar o TCG Stacked. Por favor, compartilhe seus pensamentos conosco.',
    categoryLabel: 'Categoria',
    categories: {
      bug: 'Relatório de Bug',
      feature: 'Solicitação de Recurso',
      improvement: 'Sugestão de Melhoria',
      general: 'Feedback Geral',
      other: 'Outro',
    },
    messageLabel: 'Seu Feedback',
    messagePlaceholder: 'Por favor, compartilhe seus pensamentos, sugestões ou relate um problema...',
    ratingLabel: 'Avalie Sua Experiência (Opcional)',
    emailLabel: 'Email (Opcional)',
    emailPlaceholder: 'seu@email.com',
    emailHelp: 'Forneça seu email se desejar que entremos em contato com você.',
    submitting: 'Enviando...',
    submitButton: 'Enviar Feedback',
    successMessage: 'Obrigado pelo seu feedback!',
    errorMessage: 'Falha ao enviar feedback. Por favor, tente novamente.',
  },
  hero: {
    game: {
      pokemon: {
        tab: 'Pokemon',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'Pesquise qualquer carta...',
      },
      sets: {
        placeholder: 'Pesquise qualquer coleção de cartas...',
      },
      button: 'Pesquisar',
      hint: {
        cards: 'Pressione Enter ou clique em Pesquisar para encontrar suas cartas',
        sets: 'Pressione Enter ou clique em Pesquisar para encontrar suas coleções',
      },
      aria: {
        searchIcon: 'Ícone de pesquisa',
        searchInput: {
          cards: 'Pesquisar cartas',
          sets: 'Pesquisar coleções',
        },
      },
    },
  },
  mtg: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Cartas', 'Terrenos', 'Criaturas', 'Artefatos', 'Planeswalkers'],
      description: 'Pesquise, navegue e crie proxies para cartas do Jogo de Cartas Colecionáveis Magic: The Gathering.',
      search: {
        cards: {
          tab: 'Cartas',
          placeholder: 'Pesquise qualquer carta de MTG...',
          error: 'Falha ao buscar cartas aleatórias de MTG',
        },
        sets: {
          tab: 'Coleções',
          placeholder: 'Pesquise qualquer coleção de cartas de MTG...',
        },
        button: 'Pesquisar',
        hint: {
          cards: 'Pressione Enter ou clique em Pesquisar para encontrar suas cartas',
          sets: 'Pressione Enter ou clique em Pesquisar para encontrar suas coleções',
        },
        aria: {
          searchIcon: 'Ícone de pesquisa',
          searchInput: {
            cards: 'Pesquisar cartas Magic',
            sets: 'Pesquisar coleções Magic',
          },
        },
      },
      images: {
        cardAlt: 'Imagem de carta Magic',
      },
      processedCount: 'Explore mais de {{count}} cartas de Magic: The Gathering em nosso banco de dados!',
    },
  },
  customizeCardModal: {
    title: 'Personalizar Carta com IA',
    description: 'Descreva como você gostaria de personalizar esta carta. A IA gerará uma nova versão mantendo o quadro e a estrutura da carta.',
    buttonText: 'Personalizar com IA',
    placeholder: 'Descreva a variação personalizada da carta...',
    generateButton: 'Gerar Carta Personalizada',
    generatingButton: 'Gerando...',
    addToPrintListButton: 'Adicionar à Lista de Impressão',
    successMessage: 'Carta personalizada adicionada à lista de impressão',
    cancelledGeneration: 'Geração de carta cancelada',
    remainingGenerationsOne: '{{count}} geração restante este mês',
    remainingGenerationsOther: '{{count}} gerações restantes este mês',
    error: {
      failed: 'Falha ao gerar carta personalizada',
    },
  },
  pokemon: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Cartas', 'Pokémon', 'Treinadores', 'Energia', 'Estádios'],
      description: 'Pesquise, navegue e crie proxies para cartas do Jogo de Cartas Colecionáveis Pokémon.',
      search: {
        cards: {
          tab: 'Cartas',
          placeholder: 'Pesquise qualquer carta Pokémon...',
          error: 'Falha ao buscar cartas aleatórias de Pokémon',
        },
        sets: {
          tab: 'Coleções',
          placeholder: 'Pesquise qualquer coleção de cartas Pokémon...',
        },
        button: 'Pesquisar',
        hint: {
          cards: 'Pressione Enter ou clique em Pesquisar para encontrar suas cartas',
          sets: 'Pressione Enter ou clique em Pesquisar para encontrar suas coleções',
        },
        aria: {
          searchIcon: 'Ícone de pesquisa',
          searchInput: {
            cards: 'Pesquisar cartas Pokémon',
            sets: 'Pesquisar coleções Pokémon',
          },
        },
      },
      images: {
        cardAlt: 'Imagem de carta Pokémon',
      },
      processedCount: 'Explore mais de {{count}} cartas Pokémon em nosso banco de dados!',
    },
    sets: {
      heading: 'Coleções de Cartas Pokémon',
      latestSets: 'Coleções Mais Recentes',
      upcomingSets: 'Próximas Coleções',
      allSets: 'Todas as Coleções',
      noResults: 'Nenhum resultado encontrado.',
      sortBy: 'Ordenar por',
      sort: {
        nameAsc: 'Nome (A a Z)',
        nameDesc: 'Nome (Z a A)',
        releaseDateDesc: 'Data de Lançamento (Mais Recente Primeiro)',
        releaseDateAsc: 'Data de Lançamento (Mais Antigo Primeiro)',
      },
      filterBy: 'Filtrar por série',
      allSeries: 'Todas as Séries',
    },
    set: {
      notFound: 'Coleção Pokémon não encontrada.',
      backToSets: 'Voltar para Coleções',
      cards: 'cartas',
      released: 'Lançado',
      noCards: 'Nenhuma carta encontrada nesta coleção.',
      tryAdjusting: 'Tente ajustar sua pesquisa para encontrar o que está procurando.',
      sortBy: 'Ordenar por',
      filterBy: 'Filtrar por',
      allTypes: 'Todos os Tipos',
      allRarities: 'Todas as Raridades',
      searchPlaceholder: 'Pesquisar cartas nesta coleção...',
    },
    card: {
      notFound: 'Carta Pokémon não encontrada.',
      backToSearch: 'Voltar para Pesquisa',
      addToPrintList: 'Adicionar à Lista de Impressão',
      removeFromPrintList: 'Remover da Lista de Impressão',
      inPrintList: 'Na Lista de Impressão',
      buyOn: 'Comprar no TCGplayer',
      details: 'Detalhes',
      type: 'Tipo',
      rarity: 'Raridade',
      set: 'Coleção',
      artist: 'Artista',
      number: 'Número da Carta',
      flavorText: 'Texto de Ambientação',
      attacks: 'Ataques',
      abilities: 'Habilidades',
      weakness: 'Fraqueza',
      resistance: 'Resistência',
      retreatCost: 'Custo de Recuo',
      legality: 'Legalidade',
      otherVersions: 'Outras Versões',
      youMightAlsoLike: 'Você também pode gostar...',
    },
  },
  creditPurchaseModal: {
    title: 'Comprar Créditos de Geração de IA',
    description: 'Compre créditos adicionais de geração de IA para personalizar mais cartas.',
    buttonText: 'Comprar Créditos',
    currentCredits: 'Créditos Atuais',
    selectPackage: 'Selecionar Pacote de Créditos',
    purchase: 'Comprar Agora',
    noCreditsWarning: 'Nenhum crédito disponível',
    lowCreditsWarning: 'Poucos créditos restantes',
    buyCredits: 'Comprar Créditos',
    remainingGenerationsOne: '{{count}} crédito',
    remainingGenerationsOther: '{{count}} créditos',
    creditPackages: {
      small: 'Pequeno',
      medium: 'Médio',
      large: 'Grande',
    },
    loadingCredits: 'Carregando informações de créditos...',
    valuePerCredit: '${value}/crédito',
    credits: 'Créditos',
    failedCheckout: 'Falha ao criar sessão de pagamento',
  },
  ai: {
    pageTitle: 'Personalize Suas Cartas Proxy com Magia de IA | TCG Stacked',
    pageDescription: 'Transforme suas cartas de Magic: The Gathering com arte personalizada gerada por IA. Exclusivo para membros Pro.',
    hero: {
      badge: 'Recurso Pro',
      title: 'Personalize Suas Cartas Proxy com Magia de IA',
      subtitle: 'Crie arte personalizada para seus proxies de Magic: The Gathering em segundos',
      cta: 'Experimente a assinatura Pro gratuitamente',
    },
    features: {
      title: 'Poderosos Recursos de IA ao Seu Alcance',
      subtitle: 'Nossa personalização com IA oferece controle criativo completo sobre suas cartas proxy de Magic: The Gathering',
      cardIntegrity: {
        title: 'Preserva a Integridade da Carta',
        description: 'Nossa IA modifica apenas a arte enquanto mantém a moldura, texto, símbolos de mana e layout da carta perfeitamente intactos.',
      },
      creativity: {
        title: 'Criatividade Ilimitada',
        description: 'Transforme suas cartas com qualquer tema ou estilo que você possa imaginar - de fantasia a ficção científica, de fotorrealismo a abstrato.',
      },
      instantResults: {
        title: 'Resultados Instantâneos',
        description: 'Gere arte personalizada em segundos sem necessidade de habilidades de design. Simplesmente descreva o que você quer ver.',
      },
      saveCreations: {
        title: 'Salve Suas Criações',
        description: 'Todas as suas cartas geradas por IA são salvas em sua conta para que você possa acessá-las a qualquer momento no seu painel.',
      },
      printAnytime: {
        title: 'Imprima a Qualquer Momento',
        description: 'Adicione suas cartas personalizadas à sua lista de proxy quando quiser e imprima-as junto com o resto da sua coleção.',
      },
    },
    credits: {
      title: 'Créditos de Geração de IA',
      subtitle: 'Personalize e transforme suas cartas proxy de Magic: The Gathering com créditos de geração de IA poderosos, acessíveis e fáceis de usar.',
      howItWorks: 'Como Funcionam os Créditos',
      step1: {
        number: '1',
        title: 'Compre créditos',
        description: 'em pacotes que se adequam às suas necessidades criativas e orçamento',
      },
      step2: {
        number: '2',
        title: 'Gere arte personalizada',
        description: 'para qualquer carta proxy de Magic: The Gathering usando 1 crédito por geração',
      },
      step3: {
        number: '3',
        title: 'Acompanhe seu uso',
        description: 'no painel da sua conta e compre mais a qualquer momento',
      },
      proAdvantage: {
        title: 'Vantagem para Membros Pro',
        description: 'Membros Pro recebem 5 Créditos de Geração de IA mensais como parte da assinatura. Junte-se ao Pro para maximizar seu potencial criativo!',
      },
      purchaseButton: 'Comprar Créditos Agora',
      unlockProButton: 'Desbloquear Assinatura Pro',
      packages: {
        title: 'Pacotes de Créditos',
        small: {
          name: 'Pequeno',
          credits: '5',
          price: '2.99',
          value: '$0.60/crédito',
        },
        medium: {
          name: 'Médio',
          credits: '15',
          price: '7.99',
          value: '$0.53/crédito',
          popular: 'Popular',
        },
        large: {
          name: 'Grande',
          credits: '30',
          price: '13.99',
          value: '$0.47/crédito',
        },
        createDesigns: 'Crie {{credits}} designs únicos de cartas',
      },
    },
  },
};

export default translations;
